export const Decrease = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.793945 10.9657L0.798095 13.1725L23.1598 13.2145L23.1556 11.0078L0.793945 10.9657Z"
      fill="currentColor"
    />
  </svg>
);
